/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { toggleUserMenu } from '../../../../state/slices/app';
// material
import { Icon } from '@insticator/insticator-ui';
import Menu from './menu/menu';
// styles
import injectSheet from 'react-jss';
import styles from './user_styles';



/* ========== ~~~~~~~~~~ USER ~~~~~~~~~~ ========== */
const User = injectSheet(styles)((props) => {
	// state
	const sidebarOpen = useSelector(state => state.app.sidebarOpen);
	const userMenuOpen = useSelector(state => state.app.userMenuOpen);
	const accountName = useSelector(state => state.account.accountName);
	const userFirstName = useSelector(state => state.session.userFirstName);
	const userLastName = useSelector(state => state.session.userLastName);
	// actions
	const dispatch = useDispatch();
	const handleMouseEnter = (e) => dispatch(toggleUserMenu(true));
	const handleMouseLeave = (e) => dispatch(toggleUserMenu(false));
	return (
		<div id="sidebar-user" className={`${props.classes.user} sidebarOpen-${sidebarOpen} userMenuOpen-${userMenuOpen}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
			<div className={`thumb`}>
				<Icon name={'user'} animation={'none'} />
			</div>
			<div className={`name`}>
				<div className={`text`}>{userFirstName} {userLastName} @{accountName}</div>
			</div>
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default User;
